export enum RealTimeEvents {
  SendChatMessage = 'SendChatMessage',
  onChatMessage = 'onChatMessage',
  CallEnqueue = 'CallEnqueue',
  CallDequeue = 'CallDequeue',
  CallAnswered = 'CallAnswered',
  CallInitiated = 'CallInitiated',
  CallOffered = 'CallOffered',
  OutboundCallInit = 'OutboundCallInit',
  CallAbandoned = 'CallAbandoned',
  IVRAbandoned = 'IVRAbandoned',
  CallDeclined = 'CallDeclined',
  VoicemailReceived = 'VoicemailReceived',
  ThirdPartyHangup = 'ThirdPartyHangup',
  OutboundCallHangup = 'OutboundCallHangup',
  AgentSale = 'AgentSale',
  OnAgentSale = 'OnAgentSale',
  AgentStatusChange = 'AgentStatusChange',
  OnAgentStatusChange = 'OnAgentStatusChange',
  SendAgentStatusChangeNotification = 'SendAgentStatusChangeNotification',
  CallCompleted = 'CallCompleted',
  ForceLogout = 'ForceLogout',
  RemoveConnectionIds = 'RemoveConnectionIds',
  IncomingChatNotification = 'IncomingChatNotification',
  IncomingChatAcceptedNotification = 'IncomingChatAcceptedNotification',
  AgentChatComplete = 'AgentChatComplete',
  RatingNotification = 'RatingNotification',
  CustomerChatEndNotification = 'CustomerChatEndNotification',
  NewChatNotification = 'NewChatNotification',
  ReceiveMessage = 'ReceiveMessage',
  OfflineMessageNotification = 'OfflineMessageNotification',
  HandoverChat = 'HandoverChat',
  MessageDelivered = 'MessageDelivered',
  OutboundEnqueue = 'OutboundEnqueue',
  OutboundCancelled = 'OutboundCancelled',
  OutboundAccepted = 'OutboundAccepted',
  LeadsAvailableForDial = 'LeadsAvailableForDial',
  OnAgentConnect = 'OnAgentConnect',
  OnAgentDisconnect = 'OnAgentDisconnect',
  CallStatusChange = 'CallStatusChange',
  OnProgramStatsChanged = 'OnProgramStatsChanged',
  OnCampaignStatsChanged = 'OnCampaignStatsChanged',
  AgentOnlineNotification = 'AgentOnlineNotification',
  AgentOfflineNotification = 'AgentOfflineNotification',
  OnAgentUpdate = 'OnAgentUpdate',
  AlertInstanceSingleNotification = 'AlertInstanceSingleNotification',
  AlertInstanceMultipleNotification = 'AlertInstanceMultipleNotification',
  AlertInstanceCompletedNotification = 'AlertInstanceCompletedNotification',
}

export interface ListenInterface {
  signature: RealTimeEvents;
  data: any;
}

export enum FunctionStatus {
  Failed = 'Failed',
  Success = 'Success',
}

export const ListenableEvents: Array<RealTimeEvents> = Object.values(RealTimeEvents);
